import React from "react";
import FACTORS_DATA from "./factors.data";
import FactorsPreview from "../factors-preview/FactorsPreview.component";
import "./Factors.style.css";
import Text from "react-text";
import * as Constants from "../../Constants/index";
import swal from "sweetalert";
import axios from "axios";
class Kids extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { collections } = this.state;
    return (
      <div className="offers-pic">
        <div className="offers-pic-container">
          <div className="offers-wow-img">
            <div className="wow-img">
              {/* <img src={require("../../assets/Gold Class preview .png").default} /> */}
            </div>
            <img src={require("../../assets/kids about (2).png").default} />
            <img src={require("../../assets/kids 1.png").default} />
            <img src={require("../../assets/kids.png").default} />
            <img src={require("../../assets/kid 2.png").default} />
          </div>
        </div>
      </div>
    );
  }
}
export default Kids;
